export default __webpack_public_path__ + "static/media/8.5391de09.jpg";